import iview from 'iview/dist/locale/en-US';

export default {
  errors: {
    server: {
      409: 'This record has been changed by another user since you started editing it',
    },
  },
  ...iview,
};
